module.exports = __webpack_public_path__ + "img/mrtlogo.eb38341c.png";